import { _ as _defineProperty } from '../defineProperty-2d1aa32d.js';
import { _ as _slicedToArray } from '../slicedToArray-a6a95674.js';
import { useState, useEffect, useCallback } from 'react';
import { USER_SUBSCRIPTION_TYPES } from '@picsart/growth-rc/types';
import analyticsService from '@picsart/rc/services/analytics';
import { u as useCheckoutModalContext } from '../CheckoutModalContext-fa8f6d02.js';
import getUserSubscriptionType from '../getUserSubscriptionType/index.js';
import redirectWithDelay from '../redirectWithDelay/index.js';
import { GTM_VALUES, subscriptionPyramid } from '../constants/index.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useStorageData = function useStorageData(_ref) {
  var checkoutGtmData = _ref.checkoutGtmData,
    _ref$redirectUrl = _ref.redirectUrl,
    redirectUrl = _ref$redirectUrl === void 0 ? '/files' : _ref$redirectUrl;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    userSubscriptionType = _useState2[0],
    setUserSubscriptionType = _useState2[1];
  var _useCheckoutModalCont = useCheckoutModalContext(),
    setIsOpen = _useCheckoutModalCont.setIsOpen,
    userSubscription = _useCheckoutModalCont.userSubscription;
  useEffect(function () {
    if (userSubscription) {
      setUserSubscriptionType(getUserSubscriptionType(userSubscription));
    }
  }, [userSubscription]);
  var openCheckoutModal = useCallback(function (forceTier, isUpgrade) {
    setIsOpen(true, {
      forceTier: forceTier,
      gtmData: _objectSpread({
        action_button: isUpgrade ? GTM_VALUES.UPGRADE_ACTION_BUTTON : GTM_VALUES.STORAGE_UPGRADE_ACTION_BUTTON
      }, checkoutGtmData),
      isMaximizerMode: subscriptionPyramid.indexOf(userSubscriptionType !== null && userSubscriptionType !== void 0 ? userSubscriptionType : 'free') >= subscriptionPyramid.indexOf('pro')
    });
  }, [setIsOpen, checkoutGtmData, userSubscriptionType]);
  var handleButtonClick = useCallback(function (isUpgrade) {
    var isGold = userSubscriptionType === USER_SUBSCRIPTION_TYPES.gold;
    var isMaxPerformance = userSubscriptionType === USER_SUBSCRIPTION_TYPES.maxPerformance;
    var isMaxStarter = userSubscriptionType === USER_SUBSCRIPTION_TYPES.maxStarter;
    var isPlus = userSubscriptionType === USER_SUBSCRIPTION_TYPES.plus;
    if (isMaxPerformance || isGold) {
      analyticsService.sendEvent('popup_action', {
        name: 'profile_dropdown',
        action_type: 'manage_storage'
      });
      redirectWithDelay(redirectUrl);
      return;
    }
    var forceTier = isMaxStarter ? 'max_performance' : isPlus ? 'pro' : null;
    openCheckoutModal(forceTier, isUpgrade);
    analyticsService.sendEvent('popup_action', {
      name: 'profile_dropdown',
      action_type: 'upgrade'
    });
  }, [userSubscriptionType, redirectUrl, openCheckoutModal]);
  return {
    handleButtonClick: handleButtonClick,
    userType: userSubscriptionType
  };
};

export { useStorageData as default };
//# sourceMappingURL=index.js.map
